if (!customElements.get('product-toggle')) {
  class ProductToggle extends HTMLElement {
    connectedCallback() {
      this.sectionId  = this.dataset.section;
      this.urlA       = this.dataset.urlA;
      this.urlB       = this.dataset.urlB;
      this.handleA    = this.dataset.handleA;
      this.handleB    = this.dataset.handleB;

      this.buttons = this.querySelectorAll('.hhd-toggle-btn');

      this._hoistStylesheets();

      this.buttons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.classList.contains('is-active') || btn.disabled) return;

          const idx = btn.dataset.index;
          const targetUrl    = idx === '0' ? this.urlA : this.urlB;
          const targetHandle = idx === '0' ? this.handleA : this.handleB;
          
          // Optimistically update UI
          this.buttons.forEach(b => {
             b.classList.toggle('is-active', b === btn);
             b.disabled = (b === btn);
             b.setAttribute('aria-pressed', b === btn);
          });

          this.dataset.activeIndex = idx;
          this._switchProduct(targetUrl, targetHandle);
        });
      });

      this._popHandler = () => this._switchProduct(window.location.pathname, null, false);
      window.addEventListener('popstate', this._popHandler);
    }

    disconnectedCallback() {
      if (this._popHandler) window.removeEventListener('popstate', this._popHandler);
    }

    /*
     * The section re-renders inline <link rel="stylesheet"> tags on every AJAX swap.
     * Moving them to <head> once means a later `sectionEl.innerHTML = ...` swap never
     * detaches an already-applied stylesheet — that detach was what made modals
     * (size guide, ATC) flash unstyled for a frame while toggling MEN/WOMEN.
     */
    _hoistStylesheets() {
      const sectionEl = document.querySelector(`.section-${this.sectionId}`);
      if (!sectionEl) return;

      sectionEl.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
        const alreadyInHead = link.href && document.head.querySelector(`link[rel="stylesheet"][href="${link.href}"]`);
        if (alreadyInHead) {
          link.remove();
        } else {
          document.head.appendChild(link);
        }
      });
    }

    async _switchProduct(url, handle, pushState = true) {
      const sectionEl = document.querySelector(`.section-${this.sectionId}`);
      if (!sectionEl) return;

      const savedUrlA    = this.urlA;
      const savedUrlB    = this.urlB;
      const savedHandleA = this.handleA;
      const savedHandleB = this.handleB;
      const savedSection = this.sectionId;
      const savedIndex   = this.dataset.activeIndex;

      if (pushState && handle) {
        window.history.pushState({ handle }, '', url);
      }

      const productArea = sectionEl.querySelector('.product--hhd');
      if (productArea) {
        productArea.classList.add('is-loading');
      }

      try {
        const res = await fetch(`${url}?section_id=${savedSection}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const html   = await res.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newSec = parsed.querySelector(`.section-${savedSection}`);

        if (!newSec) throw new Error(`Section ".section-${savedSection}" not found in response`);

        // Stylesheets already live in <head> (see _hoistStylesheets) and inline
        // <script src> tags never execute via innerHTML anyway — strip both so the
        // swap doesn't re-detach applied styles or leave dead script tags behind.
        newSec.querySelectorAll('link[rel="stylesheet"], script[src]').forEach(el => el.remove());

        sectionEl.innerHTML = newSec.innerHTML;

        const newToggle = sectionEl.querySelector('product-toggle');
        if (newToggle) {
          newToggle.urlA    = savedUrlA;
          newToggle.urlB    = savedUrlB;
          newToggle.handleA = savedHandleA;
          newToggle.handleB = savedHandleB;
          newToggle.dataset.urlA    = savedUrlA;
          newToggle.dataset.urlB    = savedUrlB;
          newToggle.dataset.handleA = savedHandleA;
          newToggle.dataset.handleB = savedHandleB;
          newToggle.dataset.activeIndex = savedIndex;
        }

      } catch (err) {
        console.error('[HHD Toggle] Failed to switch product:', err);
      } finally {
        // Re-query instead of reusing `productArea`: on success the whole subtree
        // (including the old node) was just replaced by sectionEl.innerHTML above.
        const currentProductArea = sectionEl.querySelector('.product--hhd');
        if (currentProductArea) currentProductArea.classList.remove('is-loading');
      }
    }
  }

  customElements.define('product-toggle', ProductToggle);
}
